module.exports = __webpack_public_path__ + "img/approve-cancel-reservation.351afe5c.svg";